import { DeskingModeCTAValue } from '../types/dealModeEnum';
import { useSelector, useDispatch } from 'react-redux';
import * as dealModeSelectors from '../selectors/dealModeSelectors';
import * as dealModeActionCreators from '../actions/dealModeActionCreators';
import * as interactionAnalyticsActionCreators from '../actions/interactionAnalyticsActionCreators';

export const useChangeDealMode = () => {
    const isFnIDealMode = useSelector(dealModeSelectors.isFnIDealMode);
    const dispatch = useDispatch();

    const handleChangeDealMode = (newDealModeValue: DeskingModeCTAValue) => {
        const selectedValue = isFnIDealMode ? DeskingModeCTAValue.FnIMode : DeskingModeCTAValue.DeskingMode;

        if (newDealModeValue === selectedValue) {
            return;
        }

        // CDL3 analytics for mode switching (dc-mv-275, dc-mv-276)
        if (newDealModeValue === DeskingModeCTAValue.FnIMode) {
            dispatch(interactionAnalyticsActionCreators.mvChangeToFIMode());
        } else {
            dispatch(interactionAnalyticsActionCreators.mvChangeToDeskingMode());
        }

        dispatch(dealModeActionCreators.toggleDeskingMode(!isFnIDealMode));
    };

    return { handleChangeDealMode };
};
